module.exports = __webpack_public_path__ + "static/media/ks_shack_floor_tablet_highlight.bed7b5f3.svg";